import React from 'react';

interface Props {
	className?: string;
	onClick?: () => void;
}

const CloseSVG: React.FC<Props> = ({ className = '', onClick }) => {
	return (
		<svg className={className} onClick={() => onClick && onClick()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M19 5L5 19M5 5L19 19" stroke="#A89CB4" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default CloseSVG;
